<div class="add-credit">
  <mat-form-field>
    <input matInput [(ngModel)]="code" placeholder="Coupon Code" (keyup.enter)="coupon ? removeCode() : redeemCode()">
  </mat-form-field>
  <div *ngIf="!coupon" class="pv-button" (click)="redeemCode()">Apply</div>
  <div *ngIf="coupon" class="pv-button warn" (click)="removeCode()">Remove</div>
</div>
<div class="warn-color">
  {{ errorMessage }}
</div>
<div class="current-coupon" *ngIf="coupon">
  <div>
    Coupon applied!  You saved <span class="bold">{{ savings | currency }}</span>
  </div>
</div>